export default __webpack_public_path__ + "static/awards-mb-co-6ffc2376ec4706304d4cc6944e8a4b63.png";